












































import {Component, Mixins, Prop, Vue} from "vue-property-decorator";
import { AccountingPointIndications } from "@/models/accounting-point";
import SimpleCard from "../SimpleCard.vue";
import NewValueForm from "./CountersNewValueForm.vue";
import ContractIcon from "@/components/ContractIcon.vue";
import SimpleCardWithList from "@/components/SimpleCardWithList.vue";
import {mapGetters} from "vuex";
import AppApiMixin from "@/components/mixins/AppApi.vue";

@Component({
  components: {
    SimpleCard,
    ContractIcon,
    NewValueForm,
    SimpleCardWithList
  },
  computed: {
    ...mapGetters({ accountingPoints: "accountingPoints/allPoints" })
  },
})
class EquipmentListCard extends Mixins(AppApiMixin) {
  @Prop({required: true}) readonly equipment!: AccountingPointIndications;

  get flowMeter() {
    return this.equipment.расходомер == 1;
  }

  get disabled() {
    return this.equipment.запретвводапоказаний != 0;
  }

  equipmentPointAddress(ls) {
    const accountingPoint = this.accountingPoints.filter((_) => _.лицевой == ls)[0];
    return accountingPoint.адрес || "";
  }

  get counterData() {
    const {типсчетчика, заводскойномер, услуга, тип, тарифность, коэфтр} = this.equipment;

    return [
      {title: 'марка', value: типсчетчика},
      {title: 'заводской номер', value: заводскойномер},
      {title: 'услуга', value: услуга},
      {title: 'тип', value: this.flowMeter ? 'Расходомер' : тип}, // переопределяем для расходомера
      {title: 'тарифность', value: тарифность},
      {title: 'коэф.тр', value: коэфтр},
    ]
  }
}

export default EquipmentListCard;
